import { CHAT_WIDGET_DIV_ID, CONSENT_BLACKBAR_DIV_ID, BANNER_DIV_ID } from 'constants/HTMLAttributes';
import { useRef, useEffect } from 'react';

// Array of element IDs to ignore when handling outside clicks
const IGNORED_ELEMENT_IDS = [CHAT_WIDGET_DIV_ID, CONSENT_BLACKBAR_DIV_ID, BANNER_DIV_ID];

export default function useOutsideClickHandler<T extends HTMLElement>(callback: (() => void) | undefined) {
  const element = useRef<T>(null);

  useEffect(() => {
    document.body.addEventListener('click', handler, { passive: true, capture: true });
    return () => document.body.removeEventListener('click', handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element, callback]);


  const handler = (event: MouseEvent) => {
    // Check if the click was inside any of the ignored elements
    const isClickedIgnoredElement = IGNORED_ELEMENT_IDS.some(id => 
      document.getElementById(id)?.contains(event.target as HTMLElement)
    );

    if (!isClickedIgnoredElement) {
      const clickedElement = event.target;
      const parentElement = element.current;
      const hasClickedSelf = clickedElement === parentElement;
      const hasClickedChild = parentElement && parentElement.contains(clickedElement as HTMLElement);
      const hasClickedOutside = !hasClickedSelf && !hasClickedChild && parentElement;
      if (hasClickedOutside && callback) {
        callback();
      }
    }
  };

  return element;
}
